import { Property } from "csstype";

export const darkModeTextShadow: Property.TextShadow =
  "1px 1px 2px #000000, 1px 1px 2px #000000, 1px 1px 2px #000000";
